export const frontEndBaseUrl = window.location.origin.includes('localhost') || window.location.origin.includes('127.0.0.1') || window.location.origin.includes('login.dev.pulseright.io')
  ? 'https://kangaroocare-bangalore.pulseright.io'
  : window.location.origin;
